(function () {
  const drawerToggle = document.getElementById('Details-menu-drawer-container');
  if (!drawerToggle) return;
  const hamburger = drawerToggle.querySelector(':scope > summary');
  const searchModal = document.querySelector('#menu-drawer .header__search');
  const headerDrawerEl = document.querySelector('header-drawer');

  // CAUSE A — closeMenuDrawer() strips `open` from nested <details> (including
  // Search's) directly, bypassing DetailsModal.close(). Whenever the Drawer
  // finishes closing, force Search's own real cleanup via its public close()
  // method instead of duplicating its internal logic.
  new MutationObserver(() => {
    if (!drawerToggle.classList.contains('menu-opening') && searchModal && typeof searchModal.close === 'function') {
      searchModal.close(false);
    }
  }).observe(drawerToggle, { attributes: true, attributeFilter: ['class'] });

  // CAUSE B (guard) — closeAnimation() removes `open` asynchronously via
  // requestAnimationFrame, which can be delayed indefinitely (or suspended
  // entirely while document.hidden). If a stray/zombie closeAnimation() call
  // removes `open` while the Drawer is logically open again (.menu-opening
  // present), restore it immediately to avoid a broken visual state.
  new MutationObserver(() => {
    if (!drawerToggle.hasAttribute('open') && drawerToggle.classList.contains('menu-opening')) {
      drawerToggle.setAttribute('open', '');
    }
  }).observe(drawerToggle, { attributes: true, attributeFilter: ['open'] });

  // CAUSE B (fix) — MenuDrawer.onSummaryClick() decides open vs close by
  // reading `hasAttribute('open')`, which can still be true after a close
  // (see above) even though the Drawer is already visually closed. Scoped
  // strictly to the Header Drawer's own root summary (never submenus): if a
  // click was misread as a close because `open` was stale, self-correct by
  // opening for real via the existing public openMenuDrawer() method.
  let wasOpenBeforeClick = false;
  hamburger.addEventListener(
    'click',
    () => {
      wasOpenBeforeClick = drawerToggle.classList.contains('menu-opening');
    },
    true
  );
  hamburger.addEventListener('click', () => {
    const isOpenNow = drawerToggle.classList.contains('menu-opening');
    if (!wasOpenBeforeClick && !isOpenNow && drawerToggle.hasAttribute('open')) {
      headerDrawerEl.openMenuDrawer(hamburger);
    }
  });
})();
